import styled, { css } from 'styled-components';

// Styled Components
import { Container, Th } from '../../summaryTables/SummaryTablesStyles';

// Components
import DropDownInput from '../../../../inputs/DropDown/DropDownInput';
import { CheckBox } from '../../../../inputs/CheckBox';

// Types
import { DisabledType, leftTableCellProps, rightTableCellProps } from './types';
import { DropDownHeader } from '../../../../inputs/DropDown/DropDownInput/styles';
import { DropDownListContainer } from '../../../../inputs/DropDown/DropDownList/styles';
import InputText from '../../../../inputs/InputText';

export const FiltersContainer = styled.div`
  display: flex;
  align-items: end;
  gap: ${({ theme }) => theme.spacing.m};
  div:last-child {
    flex: 1;
  }
`;

export const DropDownFilterStyled = styled(DropDownInput)`
  ${DropDownHeader} {
    height: 4.5rem;
  }
`;

export const InputTextFilterStyled = styled(InputText)`
  input {
    height: 4.5rem;
  }
`;

export const OperatorsTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.l};
  flex: 1;
  max-width: 90.1rem;
  width: 100%;

  /* ✅ FIX Task 11: Reducir max-width en pantallas medianas (~1400-1920px) para evitar overflow con sidebar */
  @media (max-width: 120rem) {
    max-width: 75rem;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    max-width: initial;
  }
`;

export const VehiclesTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${({ theme }) => theme.spacing.l};
  max-width: 90.1rem;
  width: 100%;

  /* ✅ FIX Task 11: Reducir max-width en pantallas medianas (~1400-1920px) para evitar overflow con sidebar */
  @media (max-width: 120rem) {
    max-width: 75rem;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    max-width: initial;
  }
`;

export const ContainerTable = styled(Container)`
  display: flex;
  gap: 9.8rem;

  /* ✅ FIX Task 11: Pantallas medianas (~1400-1920px) - reducir gap cuando espacio es limitado por sidebar */
  @media (max-width: 120rem) {
    gap: 4rem;
  }

  /* Flex-wrap para pantallas más pequeñas */
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    flex-wrap: wrap;
    gap: 3.2rem;
  }

  /* Stack vertical en tablets/móviles */
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
    gap: 3.2rem;
  }
`;

export const ContainerInput = styled.div``;

export const TableLeftTh = styled(Th)<leftTableCellProps>`
  ${({ cell }) =>
    ({
      select: css`
        width: 1rem;
      `,
      firstName: css`
        width: 15rem;
      `,
      lastName: css`
        width: 40rem;
      `,
      concession: css``,
    })[cell]};
`;

export const TableRightTh = styled(Th)<rightTableCellProps>`
  ${({ cell }) =>
    ({
      select: css`
        width: 1rem;
      `,
      plate: css`
        width: 20rem;
        @media (max-width: ${({ theme }) =>
            theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
          width: 15rem;
        }
      `,
      concession: css`
        width: 20rem;
        @media (max-width: ${({ theme }) =>
            theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
          width: 15rem;
        }
      `,
      driver: css`
        width: 24rem;
        @media (max-width: ${({ theme }) =>
            theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
          width: 21rem;
        }
      `,
      remove: css``,
    })[cell]};
`;

export const DropDownInputStyled = styled(DropDownInput)<DisabledType>`
  /* ✅ FIX Task 12: Forzar ancho máximo para que coincida con la columna Th */
  max-width: 24rem;
  width: 100%;

  @media (max-width: 120rem) {
    max-width: 21rem;
  }

  ${DropDownHeader} {
    padding: 0;
    height: initial;
    &:focus {
      outline: none;
    }
    background: ${(isDisabled) => isDisabled && 'none'};
  }
  ${DropDownListContainer} {
    z-index: 1;
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    width: 100%;
    max-width: initial;
  }
`;

export const CheckBoxStyled = styled(CheckBox)`
  &:checked {
    background-color: ${({ theme }) => theme.colors.greyDark};
  }
`;

export const CheckBoxStyledHeader = styled(CheckBox)`
  border-color: ${({ theme }) => theme.colors.white};

  &:checked {
    background-color: ${({ theme }) => theme.colors.greyDark};
  }
`;

export const Img = styled.img`
  width: 1.5rem;
  height: 2rem;
  cursor: pointer;
`;
